import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  OnChanges,
  Renderer2,
  SimpleChanges,
  OnInit,
  Injector,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICanSize, TSize } from '../../../base/common-behaviors/size';
import { BindHostClasses } from '../../../base/bind-host-classes/bind-host-classes';
import { SkyUiIconService } from '../../service/icon';

@Component({
  selector: 'sky-ui-icon',
  template: `
    <svg *ngIf="name">
      <svg:use [attr.xlink:href]="'#' + name!"></svg:use>
    </svg>
    <div *ngIf="svgContent" [innerHTML]="trustedSvgContent"></div>
  `,
  styleUrls: ['icon.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkyUiIconComponent implements ICanSize, OnInit, OnChanges {
  @Input() name?: string;
  @Input() svgContent?: string;
  @Input() size?: TSize;
  @Input() width?: number | string;
  @Input() height?: number | string;

  trustedSvgContent: SafeHtml;

  private hostClasses = new BindHostClasses(this.injector, {
    size: { prefix: 'size' },
  });

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private domSanitized: DomSanitizer,
    private injector: Injector,
    private skyUiIconService: SkyUiIconService,
  ) {}

  ngOnInit(): void {
    this.hostClasses.onInit(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.hostClasses.onUpdate(changes);

    if (changes.svgContent) {
      this.trustedSvgContent = this.domSanitized.bypassSecurityTrustHtml(this.svgContent!);
    }

    if (changes.name && this.name) {
      this.skyUiIconService.createIconSymbol(this.name);
    }

    if (changes.width || changes.height) {
      this.updateSize();
    }
  }

  private updateSize(): void {
    const width = this.width ? `${this.width}px` : null;
    const height = this.height ? `${this.height}px` : null;

    this.renderer.setStyle(this.elementRef.nativeElement, 'width', width);
    this.renderer.setStyle(this.elementRef.nativeElement, 'height', height);
  }
}
